import { useDispatch, useSelector } from "react-redux";

import { tableSortingChangedAction } from "app/pages/sales-intelligence/sub-modules/contacts-search/store/action-creators";
import { selectSortingBy } from "app/pages/sales-intelligence/sub-modules/contacts-search/store/selectors";
import type { ContactsSearchSortBy } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/common";

export const useContactsSorting = () => {
    const dispatch = useDispatch();
    const sortBy: ContactsSearchSortBy | undefined = useSelector(selectSortingBy);

    const handleSoringChange = (orderBy: string, asc: boolean) => {
        dispatch(tableSortingChangedAction({ orderBy, asc }));
    };

    return {
        sortBy,
        handleSoringChange,
    };
};
